import { signIn } from '@/api'
import { checkMobile } from '@/utils'
import { Button, Form, Input, Toast } from 'antd-mobile'
// import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

function Sign() {
  // const [visible, setVisible] = useState(true)

  const navigate = useNavigate()

  const handleSign = async (values: any) => {
    try {
      await signIn({ name: 'xxx', company: 'xxx', province: 'xxx', ...values })
      navigate(`/signsuccess?phone=${values.phone}`, { replace: true })
      // setVisible(false)
      // Modal.alert({
      //   title: '提示',
      //   content: '签到成功！',
      //   confirmText: '确定',
      //   onConfirm: () => {
      //     history.go(-1)
      //   },
      // })
    } catch (err: any) {
      Toast.show({ content: err })
    }
  }

  return (
    <div className='pb-6'>
      <h3 className='text-center text-2xl mt-4 mb-8 font-bold'>签到</h3>
      {/* {visible ? ( */}
      <Form
        // layout="horizontal"
        onFinish={handleSign}
        footer={
          <Button block type='submit' color='primary' size='large'>
            签到
          </Button>
        }
      >
        <Form.Item
          name='phone'
          label='联系电话'
          rules={[{ required: true, validator: checkMobile }]}
        >
          <Input placeholder='请输入联系电话' />
        </Form.Item>
      </Form>
      {/* ) : (
        <div className='pt-6'>
          <Result status='success' title='签到成功！' />
        </div>
      )} */}
    </div>
  )
}

export default Sign
